import styled from 'styled-components';

export const PageContainer = styled.div`
  height: 100%;
  padding: 20px;
  overflow-y: auto;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
`;
